import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-select/dist/react-select.css';

import App from './components/App.jsx';
//import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(React.createElement(Router, null, React.createElement(App)), document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js